export const PERMISSIONS = Object.freeze({
  CANDIDATE_BLACKLIST_MANAGE: "/candidates/blacklist/manage",
  CANDIDATE_PUBLIC_PLATFORM_MANAGE: "/candidates/public-platform/manage",
  DATA_CENTER_FINANCE_TAB: "/admin/tabs/finance",
  DATA_CENTER_CUSTOMER_TAB: "/admin/tabs/customer",
  DATA_CENTER_OPTION_TAB: "/admin/tabs/option",
  DATA_CENTER_PROJECT_TAB: "/admin/tabs/project",
  DATA_CENTER_EXPERT_RECRUITMENT_TAB: "/admin/tabs/expert-recruitment",
  DATA_CENTER_SALES_DATA_TAB: "/admin/tabs/sales-data",
  DATA_CENTER_CHART_TAB: "/admin/tabs/chart",
  MEETING_RECORDING_CANCEL: "/meeting-recordings/cancel",
  MEETING_RECORDING_STOP: "/meeting-recordings/stop",
  MEETING_MANAGE: "/meetings/manage",
  MEETING_SETTLE: "/meetings/settle",
  TOPIC_MANAGE: "/topics/manage",
  FINANCE_INVOICE_APPLY_ISSUE_APPROVAL: "/finance_invoices/apply_issue_approval",
  FINANCE_INVOICE_UPLOAD_INVOICE: "/finance_invoices/upload_invoice"
});
